import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { History, KeyRound, LogOut, Moon, ShieldUser, Sun } from 'lucide-react';

import { useLogout, useMe } from '../../hooks';
import { applyTheme, currentTheme, type Theme } from '../../lib/theme';
import styles from './UserMenu.module.css';

export function UserMenu() {
  const navigate = useNavigate();
  const { data: session } = useMe();
  const logout = useLogout();

  const [theme, setTheme] = useState<Theme>(() => currentTheme());
  const dark = theme === 'dark';

  const toggleTheme = () => {
    const next: Theme = dark ? 'light' : 'dark';
    applyTheme(next);
    setTheme(next);
  };

  const handleLogout = () => {
    logout.mutate(undefined, {
      onSettled: () => navigate('/login', { replace: true }),
    });
  };

  if (!session) return null;
  const { username, role, team, job } = session.user;
  const isAdmin = role === 'admin';

  return (
    <div className={styles.wrap}>
      <button
        type="button"
        onClick={toggleTheme}
        className={styles.themeBtn}
        title={dark ? 'Светлая тема' : 'Тёмная тема'}
        aria-label={dark ? 'Светлая тема' : 'Тёмная тема'}
      >
        {dark ? <Sun size={14} strokeWidth={1.5} /> : <Moon size={14} strokeWidth={1.5} />}
      </button>

      {isAdmin && (
        <NavLink
          to="/admin/users"
          className={({ isActive }) =>
            isActive ? `${styles.adminBtn} ${styles.adminBtnActive}` : styles.adminBtn
          }
          title="Управление пользователями"
          aria-label="Управление пользователями"
        >
          <ShieldUser size={14} strokeWidth={1.5} />
        </NavLink>
      )}

      {isAdmin && (
        <NavLink
          to="/admin/activity"
          className={({ isActive }) =>
            isActive ? `${styles.adminBtn} ${styles.adminBtnActive}` : styles.adminBtn
          }
          title="Активность сотрудников"
          aria-label="Активность сотрудников"
        >
          <History size={14} strokeWidth={1.5} />
        </NavLink>
      )}

      {isAdmin && (
        <NavLink
          to="/admin/settings"
          className={({ isActive }) =>
            isActive ? `${styles.adminBtn} ${styles.adminBtnActive}` : styles.adminBtn
          }
          title="Ключи сервисов"
          aria-label="Ключи сервисов"
        >
          <KeyRound size={14} strokeWidth={1.5} />
        </NavLink>
      )}

      <span className={styles.who}>
        <span className={styles.email} title={username}>
          {username}
        </span>
        <span className={team ? styles.team : styles.teamEmpty} title="Команда и должность">
          {team ? (job ? `${team} · ${job}` : team) : 'Команда не указана'}
        </span>
      </span>

      <button
        type="button"
        onClick={handleLogout}
        disabled={logout.isPending}
        className={styles.logoutBtn}
        title="Выйти"
        aria-label="Выйти"
      >
        <LogOut size={13} strokeWidth={1.5} />
      </button>
    </div>
  );
}
